/* eslint-disable camelcase */
import { Howl } from 'howler';
import random from 'lodash/random';

const createAudio = (src, { html5, ...config }) =>
  new Howl({
    src,
    html5,
    ...config
  });

const createAudioAsync = (src, { html5, ...config }) =>
  new Promise(resolve => {
    const howl = new Howl({
      src,
      html5,
      ...config,
      onload: () => resolve(howl),
      onloaderror: () => {
        resolve({
          play: () => {},
          stop: () => {}
        });
      }
    });
  });

const isValidAudioSrc = src =>
  src.endsWith('.mp3') || src.includes('.mp3?') || src.endsWith('.wav') || src.includes('.wav?');

const stopHowl = objWithHowl => {
  if (objWithHowl.howl) {
    if (navigator.userAgent.indexOf('Firefox') !== -1) {
      // Workaround for the Firefox error on Howler stop():
      // "AbortError: The operation was aborted."
      objWithHowl.howl.pause();
      // eslint-disable-next-line no-param-reassign
      objWithHowl.howl = null;
    } else {
      objWithHowl.howl.stop();
    }
  }
};

export { createAudio, createAudioAsync, isValidAudioSrc, stopHowl, Howl };
